import React, { useState } from 'react';
import Breadcrumbs from './Breadcrumbs';
import SkillDetails from './SkillDetails';
import SkillsMatrix from './SkillsMatrix';
import { accent } from '../utils/colors';
import { createSkill } from '../utils/api';

const ContentPanel = ({ 
  selectedNode,
  findAndSelectNodeById,
  handleSelectNode,
  tree,
  apiBase,
  onSkillUpdated,
  onSkillAdded,
  onSkillDeleted,
  rootSkills = []
}) => {
  const [addMode, setAddMode] = useState(false);
  const [newTitle, setNewTitle] = useState('');
  const [newDescription, setNewDescription] = useState('');
  const [addLoading, setAddLoading] = useState(false);
  const [addError, setAddError] = useState(null);
  const [showMatrix, setShowMatrix] = useState(false);

  const handleAddSkill = async () => {
    setAddLoading(true);
    setAddError(null);
    try {
      const parentId = selectedNode ? selectedNode.id : null;
      const skill = {
        id: 0,
        parentId: parentId,
        title: newTitle,
        description: newDescription,
        level: selectedNode?.level || 0,
        orderNum: 0,
        hasChildren: false
      };
      const created = await createSkill(apiBase, skill);
      setAddMode(false);
      setNewTitle('');
      setNewDescription('');
      if (onSkillAdded) onSkillAdded(created.payload || skill);
    } catch (e) {
      setAddError(e.message);
    } finally {
      setAddLoading(false);
    }
  };

  const handleSkillDeleted = (deletedId) => {
    // Удаляем навык из дерева
    const removeFromTree = (nodes) => {
      return nodes.filter(node => {
        if (node.id === deletedId) return false;
        if (node.children) {
          node.children = removeFromTree(node.children);
        }
        return true;
      });
    };
    
    // Обновляем дерево
    const updatedTree = removeFromTree([...tree]);
    // Здесь нужно обновить дерево в родительском компоненте
    if (onSkillDeleted) onSkillDeleted(deletedId);
  };

  const filteredRootSkills = rootSkills.filter(skill => 
    skill.id !== selectedNode?.id
  );

  return (
    <div className="split-content">
      {/* Кнопка и форма добавления */}
      <div style={{ marginBottom: 18, textAlign: 'right' }}>
        {addMode ? (
          <div style={{ background: '#f7f3ff', borderRadius: 10, padding: 16, marginBottom: 10 }}>
            <input
              value={newTitle}
              onChange={e => setNewTitle(e.target.value)}
              placeholder="Название навыка"
              style={{ fontSize: 16, padding: 6, borderRadius: 6, border: `1.5px solid ${accent}`, width: '100%', marginBottom: 8 }}
              disabled={addLoading}
            />
            <textarea
              value={newDescription}
              onChange={e => setNewDescription(e.target.value)}
              placeholder="Описание навыка"
              rows={4}
              style={{ fontSize: 15, padding: 6, borderRadius: 6, border: `1.5px solid ${accent}`, width: '100%', marginBottom: 8 }}
              disabled={addLoading}
            />
            <div>
              <button
                onClick={handleAddSkill}
                style={{ background: accent, color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 16, fontWeight: 600, cursor: 'pointer', marginRight: 10 }}
                disabled={addLoading || !newTitle}
              >
                {addLoading ? 'Добавление...' : 'Добавить'}
              </button>
              <button
                onClick={() => { setAddMode(false); setAddError(null); }}
                style={{ background: '#eee', color: accent, border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}
                disabled={addLoading}
              >
                Отмена
              </button>
              {addError && <span style={{ color: 'red', marginLeft: 10 }}>{addError}</span>}
            </div>
          </div>
        ) : (
          <button
            onClick={() => setAddMode(true)}
            style={{ background: accent, color: '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}
          >
            Добавить навык
          </button>
        )}
      </div>
      {/* Хлебные крошки + переключатель */}
      <Breadcrumbs 
        node={selectedNode} 
        onCrumbClick={(id) => {
          if (!id) return;
          const found = findAndSelectNodeById(tree, id);
          if (found) handleSelectNode(found);
        }} 
      />
      <div style={{ textAlign: 'right', margin: '8px 0 14px' }}>
        <button
          onClick={() => setShowMatrix(s => !s)}
          style={{ background: showMatrix ? '#eee' : accent, color: showMatrix ? accent : '#fff', border: 'none', borderRadius: 6, padding: '8px 18px', fontSize: 16, fontWeight: 600, cursor: 'pointer' }}
        >
          {showMatrix ? 'Скрыть матрицу' : 'Показать матрицу'}
        </button>
      </div>
      {/* Матрица или детали */}
      {showMatrix ? (
        <SkillsMatrix apiBase={apiBase} />
      ) : (
        <SkillDetails 
          selectedNode={selectedNode} 
          apiBase={apiBase} 
          onSkillUpdated={onSkillUpdated} 
          onSkillDeleted={handleSkillDeleted}
          tree={tree}
          rootSkills={filteredRootSkills}
        />
      )}
    </div>
  );
};

export default ContentPanel; 